import React, { useMemo, useState } from 'react';

import { Popover } from 'antd';
import Axios from 'axios';

import styled from 'styled-components';

import { showLog } from '@libs/NwMoment';

import MiniLoading from '@components/Gui/MiniLoading';
import NwIcon from '@components/Gui/NwIcon';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const EmailItemContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 4px 12px 8px 12px;

    .email-item-left {
        cursor: pointer;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex: 1 1 0;

        @media (max-width: 720px) {
            flex-direction: column;
            align-items: flex-start;
        }

        .email-address {
            font-size: 0.9rem;
            font-weight: bold;
            text-transform: lowercase;
            flex: 1 1 0;
            text-align: right;

            @media (max-width: 720px) {
                //break words
                word-break: break-word;
                white-space: normal;
                overflow-wrap: break-word;
                word-wrap: break-word;
                hyphens: none;
                text-align: left;
                text-align-last: left;
                padding-right: 0.25em;
            }

            small {
                display: block;
                font-weight: normal;
            }
        }

        .email-contact {
            font-size: 0.8rem;
            small {
                text-transform: uppercase;
                font-size: 0.75em;
            }
            p {
                text-transform: uppercase;
                margin: 0;
                line-height: 1em;
            }
        }

        .email-buttons {
            padding: 0 1rem 0 2rem;
        }

        &.email-item-disabled {
            opacity: 0.4;
            cursor: not-allowed;
        }
    }

    .email-item-right {
        font-size: 1.5rem;
        cursor: pointer;
        padding: 0 1rem;
    }
`;

const EmailInfoPopover = styled.div`
    min-width: 20rem;
    min-height: 12rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
`;

// EMAIL OBJECT
// {
//     "ContactID":99,
//     "ContactName":"Andrea Riccadonna",
//     "ConnectionID":159,
//     "ConnectionName":"Company Address", [connection.name + (' ' + connection.surname)]
//     "ConnectionRole": "casting director",
//     "ConnectionNote": "note on this connection",
//     "ContactAlert": "Alert on contact"
//     "Email":"company@netwalkapp.com"
//      EmailID:
//      ConnectionTypeName
//      ConnectionTypeValue
//      ConnectionSubTypeID
//      ContactSubTypeName
//      ContactSubTypeValue
// }

const EmailSearchItem = ({
    email,
    selected,
    onSelect,
    clickable = true,
    isMobile,
    //buttons
}) => {
    const [emailInfo, setEmailInfo] = useState(null);

    // const getCompanyNameAndRole = () => {
    //     if (!email.ContactName) {
    //         return 'added manually';
    //     }
    //     let name = email.ContactName;
    //     if (email.ConnectionRole) {
    //         name += ' / ' + email.ConnectionRole;
    //     }
    //     return name;
    // };

    // const getConnectionName = () => {
    //     if (email.ConnectionName) {
    //         return email.ConnectionName;
    //     }
    //     return '';
    // };

    const addressInfo = useMemo(() => {
        let info = { CompanyNameAndRole: '', ConnectionName: '' };
        if (!email.ContactName) {
            info.CompanyNameAndRole = 'added manually';
        } else {
            info.CompanyNameAndRole = email.ContactName;
            if (email.ConnectionRole) {
                info.CompanyNameAndRole += ' / ' + email.ConnectionRole;
            }
        }
        if (email.ConnectionName) {
            info.ConnectionName = email.ConnectionName;
        }
        return info;
    }, [email, isMobile]);

    const onEmailClick = () => {
        if (clickable) {
            onSelect(email);
        }
    };

    const onEmailInfoPopover = (open) => {
        if (open) {
            Axios.get('/connections/emails/usagestats/' + email.Email).then((res) => {
                setEmailInfo({ ...res, email: email.Email });
            });
        } else {
            setEmailInfo(null);
        }
    };

    const EmailInfo = useMemo(() => {
        if (emailInfo) {
            return (
                <EmailInfoPopover>
                    <p>
                        <strong>{emailInfo.email}</strong>
                    </p>
                    <p>
                        <strong>{emailInfo.SentCount}</strong> e-mails sent
                    </p>
                    <p>
                        last e-mail sent:{' '}
                        <strong>{emailInfo.LastSentDate ? showLog(emailInfo.LastSentDate) : 'never'}</strong>
                    </p>
                </EmailInfoPopover>
            );
        } else {
            return (
                <EmailInfoPopover>
                    <MiniLoading />
                </EmailInfoPopover>
            );
        }
    }, [emailInfo]);

    return (
        <EmailItemContainer>
            <div
                className={`email-item-left${selected ? ' email-item-disabled' : ''}`}
                onClick={() => (!selected ? onEmailClick() : null)}
            >
                <div className="email-contact">
                    <small>{addressInfo.CompanyNameAndRole}</small>
                    {addressInfo.ConnectionName &&
                        addressInfo.ConnectionName.toLowerCase() !== addressInfo.CompanyNameAndRole.toLowerCase() && (
                            <p>{addressInfo.ConnectionName}</p>
                        )}
                </div>
                <div className="email-address">
                    {selected && (
                        <NwIcon icon={byPrefixAndName.fasl['check']} size="sm" style={{ marginRight: '0.5rem' }} />
                    )}
                    <span>
                        {email.Email}
                        {email.CC && email.CC.length > 0 && <small>CC: {email.CC.join(',')}</small>}
                    </span>
                </div>
                {/* {buttons && !selected &&
                    <div className='email-buttons'>{buttons}</div>
                    } */}
            </div>
            <div className="email-item-right">
                <Popover
                    placement="left"
                    mouseEnterDelay={0.25}
                    content={EmailInfo}
                    title="E-mail address usage history"
                    onOpenChange={(open) => onEmailInfoPopover(open)}
                >
                    <NwIcon icon={byPrefixAndName.fasl['info-circle']} />
                </Popover>
            </div>
        </EmailItemContainer>
    );
};

export default EmailSearchItem;
